import { OwcTypography, OwcTooltip } from "@one/react";
import PropTypes from "prop-types";
import { valueOrEmpty } from "../../../../utils/helpers/text";
import { ElnLinkRenderer } from "@digitallab/grid-common-frontend-components";

const ElnDetails = ({ elnId }) => {
  return (
    <>
      <OwcTypography variant="caption">eLN ID</OwcTypography>

      <OwcTypography variant="button" id='attr_eln_id'>
        <ElnLinkRenderer elnExperiment={elnId} />
      </OwcTypography>
      <OwcTooltip anchor='attr_eln_id'>
        {valueOrEmpty(elnId?.name, false, "-")}
      </OwcTooltip>
    </>
  );
};

ElnDetails.propTypes = {
  elnId: PropTypes.shape({
    name: PropTypes.string,
    eid: PropTypes.string,
    modifiedAt: PropTypes.string,
    objectType: PropTypes.string,
    owner: PropTypes.string,
    state: PropTypes.string,
    type: PropTypes.string
  })
};

export default ElnDetails;
